
export default function CTASection() {
  return (
    <section className="py-16 bg-gradient-to-r from-[#0099CC] to-[#006699] relative overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10">
        {/* 限定感ブロック */}
        <div className="bg-[#FF9900] text-white px-6 py-3 rounded-full inline-block mb-6 font-bold text-sm animate-pulse">
          <i className="ri-shield-check-line mr-2"></i>
          審査が不安な方も安心！デポジット型カード
        </div>

        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            審査が不安な方の強い味方！
          </h2>
          
          {/* キャンペーン情報 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6 border-2 border-white/30">
            <p className="text-white/90 text-base mb-4">
              デポジット型だから、フリーランス・個人事業主の方も作りやすい
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FF9900] font-bold mb-1">特徴①</p>
                <p className="text-white">デポジット型で<br />審査に通りやすい</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FF9900] font-bold mb-1">特徴②</p>
                <p className="text-white">限度額<br />5万〜200万円</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FF9900] font-bold mb-1">特徴③</p>
                <p className="text-white">ETCカード<br />発行可能</p>
              </div>
            </div>
          </div>

          {/* バナー画像 */}
          <div className="mb-6">
            <a 
              href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+614CX" 
              rel="nofollow"
              target="_blank"
            >
              <img 
                border="0" 
                width="468" 
                height="60" 
                alt="デポジット型クレジットカード" 
                src="https://www26.a8.net/svt/bgt?aid=260214782225&wid=002&eno=01&mid=s00000022442001013000&mc=1"
                className="mx-auto rounded-lg shadow-lg"
              />
            </a>
            <img 
              border="0" 
              width="1" 
              height="1" 
              src="https://www18.a8.net/0.gif?a8mat=4AXB0E+3PYKNU+4T5W+614CX" 
              alt=""
              style={{ display: 'none' }}
            />
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4">
            <a
              href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
              rel="nofollow"
              target="_blank"
              className="inline-flex items-center justify-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold px-10 py-5 rounded-full transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 cursor-pointer whitespace-nowrap text-lg"
            >
              <i className="ri-external-link-line text-xl"></i>
              公式サイトで申し込む（PR）
            </a>
            <img 
              border="0" 
              width="1" 
              height="1" 
              src="https://www19.a8.net/0.gif?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE" 
              alt=""
              style={{ display: 'none' }}
            />
            <a
              href="https://apply.mycredit.nexuscard.co.jp/lp/about/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-100 text-[#0099CC] font-bold px-10 py-5 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap text-lg"
            >
              <i className="ri-information-line text-xl"></i>
              商品概要を見る
            </a>
          </div>

          {/* 安心ポイント */}
          <div className="flex flex-wrap justify-center gap-4 text-white/90 text-sm mb-4">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FF9900]"></i>
              <span>デポジット型で安心</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FF9900]"></i>
              <span>フリーランスOK</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FF9900]"></i>
              <span>個人事業主OK</span>
            </div>
          </div>

          <p className="text-white/70 text-xs">
            ※デポジット（保証金）が必要です
          </p>
        </div>
      </div>
    </section>
  );
}
